import type { ThemeAppearance } from '@atlaskit/lozenge';

export const SPF_ASK_STATUS_CONFIG: Record<
	string,
	{ display: string; appearance: ThemeAppearance }
> = {
	ACCEPTED: { display: 'Accepted', appearance: 'success' },
	CANCELED: { display: 'Canceled', appearance: 'default' },
	DEFERRED: { display: 'Deferred', appearance: 'removed' },
	DRAFT: { display: 'Draft', appearance: 'default' },
	IN_REVIEW: { display: 'In Review', appearance: 'inprogress' },
	REVISING: { display: 'Revising', appearance: 'inprogress' },
	SUBMITTED: { display: 'Submitted', appearance: 'inprogress' },
};

export const getAskStatusAppearance = (status?: string): ThemeAppearance => {
	return SPF_ASK_STATUS_CONFIG[status ?? '']?.appearance ?? 'default';
};

export const formatSpfAskStatus = (status?: string): string | undefined => {
	return status ? SPF_ASK_STATUS_CONFIG[status]?.display : undefined;
};
